import { render, staticRenderFns } from "./ChangeAccountTypeTab.vue?vue&type=template&id=6062f5b8"
import script from "./ChangeAccountTypeTab.vue?vue&type=script&lang=js"
export * from "./ChangeAccountTypeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports